// @flow
import {
  hideDialogPanel,
  showDialogPanel,
} from 'state/commands/dialogPanelCommands';
import { getActivePanelId } from 'state/selectors';
import { BACKUP_RESTORE_PROGRESS_PANEL_ID } from 'util/constants';
import type { BackupRestoreStatus, Dispatch, GetState } from 'state/types';
import { BACKUP_OPERATION_STATE } from 'util/AdminProperties';

export function showBackupRestoreProgress(
  dispatch: Dispatch,
  getState: GetState
) {
  if (getActivePanelId(getState()) !== BACKUP_RESTORE_PROGRESS_PANEL_ID) {
    dispatch(showDialogPanel(BACKUP_RESTORE_PROGRESS_PANEL_ID));
  }
}

export function hideBackupRestoreProgress(
  dispatch: Dispatch,
  getState: GetState
) {
  if (getActivePanelId(getState()) === BACKUP_RESTORE_PROGRESS_PANEL_ID) {
    dispatch(hideDialogPanel());
  }
}

export function isBackupRestoreBusy(backupRestoreStatus: ?BackupRestoreStatus) {
  const backupRestoreState =
    backupRestoreStatus && backupRestoreStatus.currentOperationState;
  return [
    BACKUP_OPERATION_STATE.BACKUP_PREFLIGHT,
    BACKUP_OPERATION_STATE.BACKUP_SHUTTING_DOWN_SERVER,
    BACKUP_OPERATION_STATE.BACKUP_BACKING_UP_DATA,
    BACKUP_OPERATION_STATE.BACKUP_RESTARTING_SERVER,
    BACKUP_OPERATION_STATE.RESTORE_SHUTTING_DOWN_SERVER,
    BACKUP_OPERATION_STATE.RESTORE_RESTORE_DATA,
    BACKUP_OPERATION_STATE.RESTORE_RESTARTING_SERVER,
  ].includes(backupRestoreState);
}

export function isRestoring(backupRestoreStatus: ?BackupRestoreStatus) {
  const backupRestoreState =
    backupRestoreStatus && backupRestoreStatus.currentOperationState;
  return [
    BACKUP_OPERATION_STATE.RESTORE_SHUTTING_DOWN_SERVER,
    BACKUP_OPERATION_STATE.RESTORE_RESTORE_DATA,
    BACKUP_OPERATION_STATE.RESTORE_RESTARTING_SERVER,
  ].includes(backupRestoreState);
}

export function isBackupRestoreSuccessful(
  backupRestoreStatus: ?BackupRestoreStatus
) {
  const backupRestoreState =
    backupRestoreStatus && backupRestoreStatus.currentOperationState;
  return [
    BACKUP_OPERATION_STATE.BACKUP_COMPLETE,
    BACKUP_OPERATION_STATE.RESTORE_COMPLETE,
  ].includes(backupRestoreState);
}

export function isBackupRestoreFailed(
  backupRestoreStatus: ?BackupRestoreStatus
) {
  const backupRestoreState =
    backupRestoreStatus && backupRestoreStatus.currentOperationState;
  return [
    BACKUP_OPERATION_STATE.BACKUP_FAILED,
    BACKUP_OPERATION_STATE.RESTORE_FAILED,
  ].includes(backupRestoreState);
}

export function isBackupRestoreCancelled(
  backupRestoreStatus: ?BackupRestoreStatus
) {
  const backupRestoreState =
    backupRestoreStatus && backupRestoreStatus.currentOperationState;
  return backupRestoreState === BACKUP_OPERATION_STATE.BACKUP_CANCELLED;
}

export function isBackupOperation(backupRestoreStatus: ?BackupRestoreStatus) {
  const backupRestoreState =
    backupRestoreStatus && backupRestoreStatus.currentOperationState;
  return [
    BACKUP_OPERATION_STATE.BACKUP_PREFLIGHT,
    BACKUP_OPERATION_STATE.BACKUP_SHUTTING_DOWN_SERVER,
    BACKUP_OPERATION_STATE.BACKUP_BACKING_UP_DATA,
    BACKUP_OPERATION_STATE.BACKUP_RESTARTING_SERVER,
    BACKUP_OPERATION_STATE.BACKUP_COMPLETE,
    BACKUP_OPERATION_STATE.BACKUP_FAILED,
    BACKUP_OPERATION_STATE.BACKUP_CANCELLED,
  ].includes(backupRestoreState);
}

export function bytesToString(bytes: number = 0) {
  const levels = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, index)).toFixed(2) + ' ' + levels[index];
}



// WEBPACK FOOTER //
// ./src/util/backupUtils.js